
import { Persona } from '../models/persona';

export class Messaggio {
    Id: number;
    Data: Date;
    Testo: string;
    Sender: Persona;
    Receiver: Persona;
    Senderid: number;
    Receiverid: number;
    Stile: string;
    Letto: string;
    Consegnato: string;
    
  constructor(){
    this.Id=0;
    this.Testo='';
    this.Data=null;
    this.Sender=new Persona();
    this.Receiver=new Persona(); 
    this.Senderid=0;
    this.Receiverid=0;
    this.Stile=''; // Imposta lo stile predefinito
    this.Letto='';
    this.Consegnato='';
  }
}
